import { ApiService } from './ApiService';
import { IGetOneResponse } from '../util/Types/Generic';

interface IGeminiChatResponse {
  status: String;
  data: {
    message: string;
    thinking: string;
    usedTokens: number;
  };
}

export class GeminiService extends ApiService {
  static pathName = '/gemini';

  static gemini = async (body: any): Promise<IGeminiChatResponse> => {
    if (body.model === 'gemini-flash') {
      body.model = 'gemini-1.5-flash';
    }

    const response = await this.post<IGeminiChatResponse>(
      `${this.pathName}/chat`,
      body,
    );

    return response;
  };

  // static geminiProVision = (
  //   query: {
  //     prompt: string;
  //     temperature: number;
  //     topP: number;
  //     topK: number;
  //     maxOutputTokens: number;
  //     fileUrl?: string;
  //     flowId?: string;
  //   },
  //   body: FormData,
  // ): Promise<
  //   IGetOneResponse<{
  //     usedTokens: any;
  //     message: string;
  //   }>
  // > => {
  //   const fileUrls = query.fileUrl ? [query.fileUrl] : [];

  //   const encodedUrls = fileUrls.map(url => encodeURIComponent(url!)).join(',');

  //   return this.post(
  //     `${this.pathName}/gemini-pro-vision?prompt=${query.prompt}${
  //       `&temperature=${query.temperature}` || ''
  //     }${`&topP=${query.topP}` || ''}${`&topK=${query.topK}` || ''}${
  //       `&maxOutputTokens=${query.maxOutputTokens}` || ''
  //     }${encodedUrls ? `&fileUrl=${encodedUrls}` : ''}${
  //       query.flowId ? `&flowId=${query.flowId}` : ''
  //     }`,
  //     body,
  //   );
  // };

  // static multiModalNew = (
  //   query: {
  //     prompt: string;
  //     temperature: number;
  //     topP: number;
  //     topK: number;
  //     maxOutputTokens: number;
  //   },
  //   body: FormData,
  // ): Promise<
  //   IGetOneResponse<{
  //     usedTokens: any;
  //     message: string;
  //   }>
  // > => {
  //   return this.post(`${this.pathName}/multi-modal-new`, body, query);
  // };

  static speechToText = ({
    fileUrl,
  }: any): Promise<
    IGetOneResponse<{
      usedTokens: any;
      message: string;
    }>
  > => {
    return this.post(
      `${this.pathName}/speech-to-text${fileUrl ? `?fileUrl=${fileUrl}` : ''}`,
    );
  };
}
